<div class="container my-3">
  <h1 class="mb-3">Profile</h1>
  <form #form="ngForm" (ngSubmit)="UpdateUser()">
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="roleId" class="form-label">Company</label>
      </div>
     <!-- standard user  and internal user-->
      <div class="col-sm-4" *ngIf="companyAccess">
        <select
          class="form-select border border-dark"
          [(ngModel)]="userDetails.CompanyId"
          name="CompanyId" id="CompanyId" disabled
        >

          <option value="0" selected>Choose Company</option>
          <option
            *ngFor="let company of companies"
            value="{{ company.Id }}"
            selected
          >
            {{ company.Name }}
          </option>
        </select>
      </div>
      <!-- Admin user -->
      <div class="col-sm-4" *ngIf="!companyAccess">
        <select
          class="form-select border border-dark"
          [(ngModel)]="userDetails.CompanyId"
          name="CompanyId" id="CompanyId"
        >

          <option value="0" selected>Choose Company</option>
          <option
            *ngFor="let company of companies"
            value="{{ company.Id }}"
            selected
          >
            {{ company.Name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="name" class="form-label">Account Type</label>
      </div>

      <!-- Normal People -->

      <div class="col-sm-4" *ngIf="accessAllRole">
        <select
          class="form-select border border-dark"
          [(ngModel)]="userDetails.RoleId"
          name="RoleId" disabled
        >
          <option
            *ngFor="let role of roles"
            [value]="role.Id"
            [selected]="role.Id === userDetails.RoleId"
          >
            {{ role.Name }}
          </option>
        </select>
      </div>

      <!-- ADMIN -->

      <div class="col-sm-4" *ngIf="!accessAllRole">
        <select
          class="form-select border border-dark"
          [(ngModel)]="userDetails.RoleId"
          name="RoleId"
        >
          <option
            *ngFor="let role of roles"
            [value]="role.Id"
            [selected]="role.Id === userDetails.RoleId"
          >
            {{ role.Name }}
          </option>
        </select>
      </div>
    </div>
<!-- for standard user -->
    <div class="row mb-3" *ngIf="accessAllRole">
      <div class="col-sm-2" style="text-align: right">
        <label for="firstName" class="form-label">First Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="firstName"
          name="firstName"
          [(ngModel)]="userDetails.FirstName" disabled
        />
      </div>
    </div>
<!-- for Admin User -->
<div class="row mb-3" *ngIf="!accessAllRole">
  <div class="col-sm-2" style="text-align: right">
    <label for="firstName" class="form-label">First Name</label>
  </div>
  <div class="col-sm-4">
    <input
      type="text"
      class="form-control border border-dark"
      id="firstName"
      name="firstName"
      [(ngModel)]="userDetails.FirstName"
    />
  </div>
</div>
<!-- non admin user -->
    <div class="row mb-3" *ngIf="accessAllRole" >
      <div class="col-sm-2" style="text-align: right">
        <label for="lastName" class="form-label">Last Name</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="lastName"
          name="lastName"
          [(ngModel)]="userDetails.LastName" disabled
        />
      </div>
    </div>
<!-- admin user -->
<div class="row mb-3" *ngIf="!accessAllRole" >
  <div class="col-sm-2" style="text-align: right">
    <label for="lastName" class="form-label">Last Name</label>
  </div>
  <div class="col-sm-4">
    <input
      type="text"
      class="form-control border border-dark"
      id="lastName"
      name="lastName"
      [(ngModel)]="userDetails.LastName"
    />
  </div>
</div>

<!-- non admin user -->
    <div class="row mb-3" *ngIf="accessAllRole">
      <div class="col-sm-2" style="text-align: right">
        <label for="email" class="form-label">Email</label>
      </div>
      <div class="col-sm-4">
        <input
          type="email"
          class="form-control border border-dark"
          id="email"
          name="email"
          [(ngModel)]="userDetails.Email" disabled
        />
      </div>
    </div>
<!-- admin user  -->
<div class="row mb-3" *ngIf="!accessAllRole">
  <div class="col-sm-2" style="text-align: right">
    <label for="email" class="form-label">Email</label>
  </div>
  <div class="col-sm-4">
    <input
      type="email"
      class="form-control border border-dark"
      id="email"
      name="email"
      [(ngModel)]="userDetails.Email"
    />
  </div>
</div>
    <!-- <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="PhoneNumber" class="form-label">Phone Number</label>
      </div>
      <div class="col-sm-4">
        <input
          type="number"
          class="form-control border border-dark"
          id="PhoneNumber"
          name="PhoneNumber"
          [(ngModel)]="userDetails.PhoneNumber"
        />
      </div>
    </div> -->
<!-- non admin user -->
    <div class="row mb-3" *ngIf="accessAllRole">
      <div class="col-sm-2" style="text-align: right">
        <label for="username" class="form-label">Username</label>
      </div>
      <div class="col-sm-4">
        <input
          type="text"
          class="form-control border border-dark"
          id="username"
          name="username"
          [(ngModel)]="userDetails.UserName" disabled
        />
      </div>
    </div>
<!-- non admin user -->
<div class="row mb-3" *ngIf="!accessAllRole">
  <div class="col-sm-2" style="text-align: right">
    <label for="username" class="form-label">Username</label>
  </div>
  <div class="col-sm-4">
    <input
      type="text"
      class="form-control border border-dark"
      id="username"
      name="username"
      [(ngModel)]="userDetails.UserName"
    />
  </div>
</div>
   <!--  <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="password" class="form-label">New Password</label>
      </div>
      <div class="col-sm-4">
        <input
          type="password"
          class="form-control border border-dark"
          id="password"
          name="password"
          [(ngModel)]="userDetails.Password"
        />
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-2" style="text-align: right">
        <label for="con_password" class="form-label">Confirm Password</label>
      </div>
      <div class="col-sm-4">
        <input
          type="password"
          class="form-control border border-dark"
          id="con_password"
          name="con_password"
          [(ngModel)]="userDetails.Password"
        />
      </div>
    </div> -->
    <div style="min-height: 50px"></div>
    <!-- other users -->
    <!-- <div class="row" *ngIf="accessUpdate">
      <div class="col-sm-2" style="text-align: right">
        <button type="submit" class="btn btn-primary m-3">Update</button>
      </div>
      <div class="col-sm-2" style="text-align: left">
        <button
          type="button"
          class="btn btn-secondary m-3"
          (click)="reloader()"
        >
          Cancel
        </button>
      </div>
    </div> -->

    <!-- Admin User -->
    <div class="row" *ngIf="!accessUpdate">
      <div class="col-sm-2" style="text-align: right">
        <button type="submit" class="btn custom-buttons-btn m-3">Update</button>
      </div>
      <div class="col-sm-2" style="text-align: left">
        <button
          type="button"
          class="btn custom-buttons-btn m-3"
          (click)="reloader()"
        >
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>
